//https://fd92407f.ngrok.io/api/User/Details/jeff-heg
export const API_URL = 'https://storyflow2020.azurewebsites.net';
